import axios from 'axios';
import { KEY_LOCALSTORAGE } from '../../../../../../auth/core/_consts';
import { OctResponse } from '../../../../../../models/OctResponse';
import { localStorageItem } from '../../../../../../utils/LocalStorage';
import { APP_CONFIGURATION_KEYS } from '../../../../../../utils/Constant';

export const API_PATH =
	localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[APP_CONFIGURATION_KEYS.API_URL] || process.env.REACT_APP_INPATIENT_API_URL;

export const getThongTinBenhAn = async (
	encounterId: string,
	form: string
): Promise<OctResponse<any>> => {
	const { data } = await axios.get<OctResponse<any>>(
		`${API_PATH}/medical-records`,
		{ params: { encounterId, form } }
	);
	return data;
};

export const updateThongTinBenhAn = async <T = any>(
  id: string,
  formName: string,
  payload: T
): Promise<OctResponse<any>> => {
  const params = new URLSearchParams({
    encounterId: id,
    form: formName
  });
  const {data} = await axios.post<OctResponse<any>>(
    `${API_PATH}/medical-records?${params.toString()}`,
    payload
  );
  return data;
};

export const updateTypeBenhAn = async (payload: any): Promise<OctResponse<any>> => {
  const {data} = await axios.post<OctResponse<any>>(`${API_PATH}/medical-records/type`, payload);
  return data;
};

export const printMedicalRecord = async (params: { encounterId: string, form?: string }) => {
	const paramsConvert = new URLSearchParams({
		...params
	});
	return await axios.post<Blob>(`${API_PATH}/medical-records/export?${paramsConvert.toString()}`, params, {
		responseType: 'blob',
	});
};

export const getMedicalRecordForm = async (medicalRecordCode: string, formName: string) => {
	const { data } = await axios.get(
		`${API_PATH}/term-models/${medicalRecordCode}_${formName}/model-json`
	);
	return data;
};

export const getDsTabBenhAn = async (encounterId: string, medicalRecordTypeCode?: string) => {
	const { data } = await axios.get(
		`${API_PATH}/medical-records/forms`,
		{ params: { encounterId, medicalRecordTypeCode } }
	);
	return data;
};
